import { render, staticRenderFns } from "./ErrorModule.vue?vue&type=template&id=38c3797c&"
import script from "./ErrorModule.vue?vue&type=script&lang=js&"
export * from "./ErrorModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports